import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=39d555fa&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=39d555fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d555fa",
  null
  
)

export default component.exports